import { generatePath } from "react-router-dom";

import { SearchSubscriptionInterval } from "@/constants";
import { SearchSubscription } from "@/types/SearchSubscription";

import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

export const createAlertSubscription = ({
  organization_uuid,
  user_id,
  ...body
}: {
  organization_uuid: string;
  search_uuid: string;
  user_id: number;
  interval: SearchSubscriptionInterval;
  insight_types?: string[];
}) => {
  return fetcher_v2<
    SearchSubscription,
    { search_uuid: string; interval: SearchSubscriptionInterval }
  >(
    generatePath(URLS.ORGANIZATION_USER_SEARCH_SUBSCRIPTIONS_CREATE, {
      organization_uuid,
      user_id,
    }),
    {
      method: "POST",
      body,
    }
  );
};

export const deleteAlertSubscription = ({
  organization_uuid,
  user_id,
  sub_id,
}: {
  organization_uuid: string;
  user_id: number;
  sub_id: number;
}) => {
  return fetcher_v2<void, void, void>(
    generatePath(URLS.ORGANIZATION_USER_SEARCH_SUBSCRIPTIONS_EDIT, {
      uuid: organization_uuid,
      user_id,
      sub_id,
    }),
    {
      method: "DELETE",
    }
  );
};

export type AvailableAlertSubscriptions = Array<SearchSubscriptionInterval>;

export const getAvailableAlertSubscriptions = (params: {
  organization_uuid: string;
  user_id: number;
}) => {
  return fetcher_v2<AvailableAlertSubscriptions, void>(
    generatePath(
      URLS.ORGANIZATION_USER_SEARCH_SUBSCRIPTIONS_AVAILABLE_LIST,
      params
    )
  );
};
